
import { Card, Icon } from "@/shared/ui/";
import {
	EditCharacterInfo,
	HealthBar,
	IntoxicationBar,
	ManaBar,
	ManageHealth,
	ManageMana,
	ManageMentalState,
	MentalStateBar,
} from "@/features";
import { defineComponent } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "CharacterInfoSection",
	components: {
		Icon,
		MentalStateBar,
		ManageMana,
		ManageMentalState,
		ManageHealth,
		EditCharacterInfo,
		IntoxicationBar,
		ManaBar,
		HealthBar,
		Card,
	},
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);

		return {
			characters,
			current,
		};
	},
});
